export const getLocale = (): string => {
    return window.localStorage.hasOwnProperty('impactLocale') ?
        String(window.localStorage.getItem('impactLocale')) : navigator.language.split('-')[0];
};

export const setLocale = (locale: string) => {
    window.localStorage.setItem('impactLocale', locale);
};
